import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { ModalComponentMediator } from "~app/common/components/modal/modal-component-mediator";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { KundorderradCreateComponent } from "../../kundorder/kundorder-details/kundorderrad-create/kundorderrad-create.component";

@Component({
    selector: "rask-create-orderrad-modal",
    templateUrl: "./create-orderrad-modal.component.html",
    styleUrls: ["./create-orderrad-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        KundorderradCreateComponent,
        SaveButtonComponent,
        ButtonComponent
    ]
})
export class CreateOrderradModalComponent {
    form: UntypedFormGroup;
    model: any;
    order: any;
    orderradAdded: any;

    private readonly modalComponentMediator = inject(ModalComponentMediator);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("data") set data(value) {
        this.order = value.order;
        this.orderradAdded = value.orderradAdded;
        this.form = value.rootForm;
    }

    abort() {
        this.close();
    }

    add() {
        if (this.canAdd()) {
            this.orderradAdded(this.model);
            this.close();
        }
    }

    canAdd() {
        const createForm = this.form.controls.kundorder0;
        return createForm && !createForm.invalid;
    }

    close() {
        this.form.removeControl("kundorder0");
        this.modalComponentMediator.getRef().close(null);
    }

    dismiss() {
        this.modalComponentMediator.getRef().close(ConfirmDialogResponse.cancel);
    }

    onModelCreated(model) {
        this.model = model;
    }
}
